
import createReducer from '../createReducer';
import { Action } from '../model';
import { 
  INSTALLATIONS_ACTION_TYPES, 
  InstallationsState, 
  INSTALLATIONS_INITIAL_STATE 
} from './types';


const reducer = {
  [INSTALLATIONS_ACTION_TYPES.FETCH_INSTALLATIONS_REQUEST]: (
    state: InstallationsState
  ): InstallationsState => ({
    ...state,
    loading: true,
    error: null,
  }),

  [INSTALLATIONS_ACTION_TYPES.FETCH_INSTALLATIONS_SUCCESS]: (
    state: InstallationsState,
    action: Action<InstallationsState['list']>
  ): InstallationsState => ({
    ...state,
    list: action.payload,
    loading: false,
    error: null,
  }),

  [INSTALLATIONS_ACTION_TYPES.FETCH_INSTALLATIONS_FAILURE]: (
    state: InstallationsState,
    action: Action<string>
  ): InstallationsState => ({
    ...state,
    loading: false,
    error: action.payload,
  }),
};

export const installationsReducer = createReducer<InstallationsState>(
  INSTALLATIONS_INITIAL_STATE,
  reducer
); 